<template>
  <div class="contact-form">

    <label>{{ $t('root.filters.operator') }}</label>
    <select v-model='predicate'>
      <option :value='true'>{{ $t('root.filters.is') }}</option>
      <option :value='false'>{{ $t('root.filters.is_not') }}</option>
    </select>

    <label>{{ $t('root.filters.folder_name') }}</label>
    <multi-select :template='folderTemplate' v-model='selectedFolders' :getter='getFolders' />

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
import _multi_select from '../../shared/_infinite_multi_select'

export default {
  components: {
    'multi-select': _multi_select,
  },
  data() {
    return {
      predicate: true,
      selectedFolders: [],
    }
  },
  computed: {
    selectedFolderIds() {
      return this.selectedFolders.map(f => f.id)
    },
    predicateQuery() {
      return this.predicate ? 'filters[folder_id_in]' : 'filters[folder_id_not_in]'
    }
  },
  methods: {
    filter() {
      let newQuery = Object.assign({}, this.query)

      delete newQuery['filters[folder_id_in]']
      delete newQuery['filters[folder_id_not_in]']

      newQuery = Object.assign({}, newQuery, { page: 1, [this.predicateQuery]: this.selectedFolderIds })

      this.$router.push({ query: newQuery })
    },
    getFolders(params) {
      return this.listStore.getSharedFolders(params)
    },
  }
}
</script>

<style lang="sass" scoped>
.contact-form
  width: 325px
  padding: 10px
  select
    margin-bottom: 15px
  .custom-select
    margin-bottom: 15px
  label
    display: block
</style>
